// @flow
import GridHeaderCellRenderer from './GridHeaderCellRenderer';

export default GridHeaderCellRenderer;
